// Constants required for MerchantConfigs and MerchantConstraints classes
// VCO-14529: Mastercard Payment Gateway Services Limited apikey
export const MPGS = 'MPGS';
